var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRotatableRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#13123A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 22.667a5.5 5.5 0 0 1-1.6-.409q-.766-.324-1.466-.858l.933-.966q.483.35 1.025.566.541.218 1.108.3zm1.334 0V21.3q1.732-.25 2.866-1.558a4.5 4.5 0 0 0 1.134-3.042q0-1.95-1.359-3.308Q17.95 12.033 16 12.034h-.133l1.066 1.066-.933.934-2.667-2.667L16 8.7l.933.967L15.9 10.7h.1q1.25 0 2.342.475a6.1 6.1 0 0 1 1.9 1.284 6.1 6.1 0 0 1 1.283 1.9Q22 15.45 22 16.7q0 2.283-1.517 3.975t-3.816 1.992M11.3 20.433a6.8 6.8 0 0 1-.858-1.466 5.5 5.5 0 0 1-.409-1.6H11.4q.084.567.3 1.108.217.542.567 1.025zm-1.267-4.4a6.3 6.3 0 0 1 .417-1.633q.317-.783.85-1.433l.967.933a4.8 4.8 0 0 0-.567 1.025q-.216.541-.3 1.108z",
    fill: "#13123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotatableRoom);
export default __webpack_public_path__ + "static/media/ic_rotatable_room.e6d1f56196b2fc4f03f3252782aa1d14.svg";
export { ForwardRef as ReactComponent };